export default "__VITE_ASSET__C_E4yBnL__"